<template>
    <AlertBanner
        variant="error"
        :message="message"
        class="alert-error"
    />
</template>

<script>
import {defineAsyncComponent} from 'vue';

export default {
    components: {
        AlertBanner: defineAsyncComponent(() => import('./AlertBanner')),
    },

    props: {
        message: String
    }
}
</script>
